import React from 'react';
import { Linkedin, ArrowUp, Facebook, Instagram } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FaWhatsapp } from 'react-icons/fa';


export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const quickLinks = [
    { label: 'About Us', href: '#who-we-are' },
    { label: 'What We Do', href: '#what-we-do' },
    { label: 'Careers', href: '#careers' },
    { label: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="bg-primary text-primary-foreground py-8 sm:py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
          {/* Copyright */}
          <div className="text-center md:text-left">
            <p className="text-sm text-primary-foreground/70">
              © 2026 Brion Enterprises LLP. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-6">
            {quickLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Social & Back to Top */}
          <div className="flex items-center justify-center md:justify-end gap-4">
            <a
              href="https://www.linkedin.com/company/brionenterprises/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61591606966051"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <Facebook className="h-5 w-5" />

            </a>
            <a
              href="https://wa.me/918433711334"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <FaWhatsapp className="h-5 w-5" />

            </a>
            <a
              href="https://www.instagram.com/brionenterprises.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <Instagram className="h-5 w-5" />

            </a>
            <Button
              variant="ghost"
              size="icon"
              onClick={scrollToTop}
              className="text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/10"
            >
              <ArrowUp className="h-5 w-5" />
            </Button>
          </div>
        </div>

        {/* Disclaimers */}
        <div className="border-t border-primary-foreground/20 pt-8 space-y-4 text-center">
          <p className="text-xs text-primary-foreground/60 leading-relaxed">Brion Enterprises LLP operates as an Authorised Person of Marwadi Shares and Finance Limited and facilitates access to securities market services, including trading and Demat account opening, through Marwadi Shares and Finance Limited.</p>

          <p className="text-xs text-primary-foreground/60 leading-relaxed">Brion Enterprises LLP also undertakes proprietary investments using its own capital. Brion does not provide investment advisory or portfolio management services.</p>

          <p className="text-xs text-primary-foreground/60 leading-relaxed">Investments in securities market are subject to market risks. Read all the related documents carefully before investing.</p>
         
        </div>
      </div>
    </footer>
  );
}